module.exports = __webpack_public_path__ + "static/media/virtusa.ed64b598.png";